import React from 'react';

/**
 * PageLoader
 *
 * Minimal full-viewport loading indicator used as the Suspense
 * fallback during route-based code splitting.
 *
 * Intentionally has zero external dependencies and uses only
 * CSS variables already defined in global.css.
 */
function PageLoader() {
  return (
    <div
      role="status"
      aria-label="Loading page"
      style={{
        display:        'flex',
        flexDirection:  'column',
        alignItems:     'center',
        justifyContent: 'center',
        minHeight:      '60vh',
        gap:            '1rem',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width:          '40px',
          height:         '40px',
          borderRadius:   '50%',
          border:         '3px solid var(--border-light)',
          borderTopColor: 'var(--primary)',
          animation:      'qs-spin 0.75s linear infinite',
        }}
      />
      <p
        style={{
          fontSize:    '0.875rem',
          color:       'var(--text-muted)',
          margin:      0,
          letterSpacing: '0.05em',
        }}
      >
        Loading…
      </p>

      {/* Keyframe injected inline to keep this component self-contained */}
      <style>{`
        @keyframes qs-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default PageLoader;
